/* global angular, _ */

var ngModule = angular.module('trends');

ngModule.directive('searchBox', ['$state', 'SearchBoxManager', 'Api', '$rootScope',
    function ($state, SearchBoxManager, Api, $rootScope) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element) {
                scope.value = '';

                scope.$watch(SearchBoxManager.getValue, function (newValue) {
                    scope.value = newValue;
                }, true);

                scope.showAdvancedLink = function () {
                    return !$state.includes('search');
                };

                scope.fireSearch = function() {
                    scope.closeAutocomplete();

                    if (!$state.includes('search')) {
                        $state.go('search', {'q': scope.value});
                    } else {
                        SearchBoxManager.setValue(scope.value);
                    }
                };

                var input = element.find('input[name="q"]');
                // Create autocomplete box
                input.autocomplete({
                    source: function (request, response) {
                        Api.autocomplete.get({term: request.term}).then(function (data) {
                            response(data.result);
                        }, function () {
                            response();
                        });
                    },
                    minLength: 2,
                    select: function (e, ui) {
                        if (ui.item.type === 'hvt') {
                            $state.go('group', {'hvt_id': ui.item.hvt_id});
                        } else {
                            $state.go('trend', {'item_id': ui.item.id});
                        }
                        e.target.value = '';
                        e.preventDefault();
                    },
                    focus: function (e) {
                        e.preventDefault();
                    },
                    appendTo: element
                });

                // Patch autocomplete with custom render
                input.data('uiAutocomplete')._renderMenu = function (ul, items) {
                    var that = this;
                    var current_category = '';
                    _.forEach(items, function (item) {
                        if (item.category !== current_category) {
                            ul.append('<li class="category">' + item.category + '</li>');
                            current_category = item.category;
                        }
                        that._renderItemData(ul, item);
                    });
                };

                // Refocus search box after view change
                $rootScope.$on('$stateChangeSuccess', function () {
                    input.tabIndex = 0;
                    input.focus();
                });

                // Close search suggestions when changing view
                scope.closeAutocomplete = function () {
                    input.autocomplete('close');
                };
                $rootScope.$on('$stateChangeStart', scope.closeAutocomplete);
            }
        };
    }
]);
